import { render, staticRenderFns } from "./_ActionsPrioritairesView.vue?vue&type=template&id=1cb6222a"
import script from "./_ActionsPrioritairesView.vue?vue&type=script&lang=js"
export * from "./_ActionsPrioritairesView.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports